const STEPS = ['Type de séance', 'Client', 'Consentement']

export default function StepIndicator({ step }) {
  return (
    <div className="flex gap-2 text-[11px] uppercase tracking-[1.4px]">
      {STEPS.map((label, i) => {
        const tone = i === step ? 'text-terra-500' : i < step ? 'text-ink' : 'text-line'
        const dot = i === step ? '●' : i < step ? '✓' : '○'
        return <span key={label} className={tone}>{dot} {label}</span>
      })}
    </div>
  )
}
